import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { createSpinner, showSpinner } from '@syncfusion/ej2-popups';
import { MessageComponent } from '@syncfusion/ej2-react-notifications';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { get } from '../../utils/Api';
import React, { useState, useEffect } from 'react';
import { env } from '../../env'
import { bogusCheck, validatePostcode } from '../../utils/ValChecker';
function PostcodeSearch(props) {
    // Declare variables using const or let
    const { provider, setValue } = props;
    const selectedAddressHtmlAttr = { name: "selectedAddressDropdown" };
    const selectedAddressFields = { text: 'formattedAddress', value: 'formattedAddress' };
    let spinnerInstance = null;

    // Declare state variables using useState
    const [isAddressSearchDisabled, setIsAddressSearchDisabled] = useState(true);
    const [isPostcodeSearching, setIsPostcodeSearching] = useState(false);
    const [isAddressSelectShown, setIsAddressSelectShown] = useState(false);
    //const [searchError, setSearchError] = useState(null);
    const [searchPostcode, setSearchPostcode] = useState('');
    const [selectedAddress, setSelectedAddress] = useState(null);

    const [postcodeState, setPostcodeState] = useState({
        foundAddresses: [],
        postcodeErrorMessage: '',
        postCodeLookupError: false,
    });

    //Declare effects using useEffect
    useEffect(() => {
        if (env.VITE_ENV && env.VITE_ENV.toLowerCase() !== 'production') {
            console.log(`PostcodeSearch.useEffect :: searchPostcode: ${searchPostcode}`);
        }
        if (searchPostcode !== '') {
            if (bogusCheck(searchPostcode) && validatePostcode(searchPostcode, 5, 10)) {
                //setSearchError(null);
                setIsAddressSearchDisabled(false);
            }
            else {
                //setSearchError('* Please enter a valid UK Postcode');
                setIsAddressSearchDisabled(true);
            }

        }
        else {
            setIsAddressSearchDisabled(true);
            setPostcodeState((prevFormData) => ({ ...prevFormData, foundAddresses: [] }));
        }
    }, [searchPostcode]);

    useEffect(() => {
        if (env.VITE_ENV && env.VITE_ENV.toLowerCase() !== 'production') {
            console.log(`PostcodeSearch.useEffect :: selectedAddress: ${selectedAddress}`);
        }

        if (selectedAddress && selectedAddress !== null) {
            setValue('address', selectedAddress);
        }
    }, [selectedAddress]);

    useEffect(() => {
        if (env.VITE_ENV && env.VITE_ENV.toLowerCase() !== 'production') {
            console.log(`PostcodeSearch.useEffect :: isPostcodeSearching: ${isPostcodeSearching}`);
        }

        if (isPostcodeSearching && spinnerInstance) {
            createSpinner({
                // Specify the target for the spinner to show
                target: spinnerInstance,
            });
            showSpinner(spinnerInstance);
        }
    }, [isPostcodeSearching])

    // Declare event handlers or other functions
    const handlePostcodeSearch = async () => {
        if (env.VITE_ENV && env.VITE_ENV.toLowerCase() !== 'production') {
            console.log(`PostcodeSearch.handlePostcodeSearch`);
        }

        setIsPostcodeSearching(true);
        const response = await get(`${provider.url}/api/v1.0/address/find?cfk=${encodeURIComponent(provider.key)}&postcode=${searchPostcode}`);
        setIsPostcodeSearching(false);

        if (response.status === 200 || response.status === 404) {
            setPostcodeState((prevFormData) => ({ ...prevFormData, foundAddresses: response.data, postCodeLookupError: response.status === 404, postcodeErrorMessage: "No addresses found for postcode, please review postcode entered or enter below." }));
            setIsAddressSelectShown(response.data.length > 0 && response.status === 200);
        } else {
            setIsAddressSelectShown(false);
            setPostcodeState((prevFormData) => ({ ...prevFormData, foundAddresses: [], postCodeLookupError: true, postcodeErrorMessage: "Unable to search for address, please try again or enter below manually." }));
        }
    };

    return (
        <div className="row">
            <div className="col-xs-12 text-label-row mb-2">
                <b className="text-label">Please enter your UK postcode below and click the button to find your address:</b>
            </div>
            <div id="postcode_lookup" className="col-xs-12 col-sm-6 col-lg-6 col-md-6 mt-2">

                <div className="container" style={{ paddingLeft: '0px' }}>
                    <div className="row">
                        <div style={{ display: 'flex', alignItems: 'baseline' }}>

                            <TextBoxComponent type="text" placeholder="Enter your Postcode" floatLabelType="Auto" width="auto" value={searchPostcode} onChange={(args) => setSearchPostcode(args.value)} />
                            <div style={{ marginLeft: '2px'}}>
                                <ButtonComponent id="searchButton" isPrimary type="button" disabled={isAddressSearchDisabled} style={{ height: '32px', width: 'auto' }} content="Search Address" onClick={() => handlePostcodeSearch()} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {!isPostcodeSearching && postcodeState.postCodeLookupError &&
                <div className="col-xs-12 mt-2">
                    <MessageComponent severity="Warning" variant="Filled" showCloseIcon={true} content={postcodeState.postcodeErrorMessage}></MessageComponent >
                </div>
            }

            {isPostcodeSearching && (
                <div ref={spinner => {
                    spinnerInstance = spinner;
                }} id="spinner" />
            )}

            <div className="col-xs-12 col-sm-6 col-lg-6 col-md-6" style={isAddressSelectShown ? {} : { display: 'none' }}>
                <DropDownListComponent
                    htmlAttributes={selectedAddressHtmlAttr}
                    fields={selectedAddressFields}
                    floatLabelType="Auto"
                    dataSource={postcodeState.foundAddresses}
                    placeholder="Select your address"
                    select={({ itemData }) => {
                        setSelectedAddress(itemData.address);
                    }}
                    value={selectedAddress}
                />
            </div>
        </div>
    );
} export default PostcodeSearch;